/**
 * Builds the browser tab title. Organizations can set a short label
 * (`tabTitleLabel`) so users running several tenants side by side can tell the
 * tabs apart — e.g. label "PRF" on the Invoices page gives
 * "Gently (PRF) - Invoices".
 */
export function buildTabTitle({
  appName,
  label,
  pageTitle,
}: {
  appName: string;
  label?: string | null;
  pageTitle?: string;
}): string {
  const trimmedLabel = label?.trim();
  const base = trimmedLabel ? `${appName} (${trimmedLabel})` : appName;
  return pageTitle ? `${base} - ${pageTitle}` : base;
}
